import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../i18n/translate.js';
import Expandable from '../../components/Expandable/Expandable.js';
import SidePanelInfoBox from '../../components/SidePanelInfoBox/SidePanelInfoBox.js';
import DeviceAdjustedForPets from './DeviceAdjustedForPets.js';
import styles from './DevicesAdjustedForPets.module.scss.js';

var DevicesAdjustedForPets = function DevicesAdjustedForPets(_ref) {
  var devices = _ref.devices,
    _onChange = _ref.onChange,
    toggleAll = _ref.toggleAll,
    expanded = _ref.expanded;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Expandable, {
    expanded: expanded,
    title: t('MPLIB_ADJUST_DEVICE_FOR_PETS_TITLE'),
    dataTestId: "devices-adjusted-for-pets"
  }, /*#__PURE__*/React.createElement(SidePanelInfoBox, {
    className: styles.noborder,
    icon: "icon-alert",
    title: t('MPLIB_SELECT_PET_TYPE_NOTE_TITLE'),
    text: t('MPLIB_ADJUST_DEVICE_FOR_PETS_INFO_TEXT')
  }), devices.map(function (device) {
    return /*#__PURE__*/React.createElement(DeviceAdjustedForPets, {
      key: device.deviceLabel.replace(/\s/g, ''),
      isToggled: toggleAll ? true : device.adjusted,
      onChange: function onChange(value) {
        _onChange(device.deviceLabel, value);
      },
      device: device
    });
  })));
};
DevicesAdjustedForPets.propTypes = {
  devices: PropTypes.arrayOf(PropTypes.shape({
    deviceLabel: PropTypes.string,
    area: PropTypes.string,
    adjusted: PropTypes.bool
  })),
  onChange: PropTypes.func.isRequired,
  toggleAll: PropTypes.bool,
  expanded: PropTypes.bool
};
DevicesAdjustedForPets.defaultProps = {
  devices: [],
  toggleAll: false,
  expanded: true
};

export { DevicesAdjustedForPets as default };
